import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import messages from "res/messages/farsi";
import FullTitleValue from "../../../components/textValue/FullTitleValue";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import {basketViewModel} from "../../../viewModels/Basket.viewModel";
import {authenticationViewModel} from "../../../viewModels/Authentication.viewModel";
import {IsNotT} from "my-styles/media/media";
import DialogMessage from "components/dialogMessage/DialogMessage";
import {Divider} from '@material-ui/core';

import ICAddress from "res/images/address_white.png";
import ICClear from "res/images/delete_white.png";
import ICDone from "res/images/done_white.png";

export default function BasketInfo(props) {

    const history = useHistory()

    const [total, setTotal] = useState(0)
    const [productsDiscount, setProductsDiscount] = useState(0)
    const [excessDiscount, setExcessDiscount] = useState(0)
    const [netTotal, setNetTotal] = useState(0)
    const [rewardDiscount, setRewardDiscount] = useState(0)
    const [totalUsedWallet, setTotalUsedWallet] = useState(0)
    const [transportationCost, setTransportationCost] = useState(0)
    const [clearBasketDialogShowStatus, setClearBasketDialogShowStatus] = useState(false)

    function prices() {
        return <>
            <FullTitleValue
                className="marginTopBottomSmall"
                title={messages.totalPrice}
                titleClassName="largeTextBold"
                value={total.toLocaleString() + " " + messages.priceUnit}
                valueClassName="grayColor largeTextBold"/>
            <FullTitleValue
                className="marginTopBottomSmall"
                title={messages.productDiscount}
                titleClassName="largeTextBold"
                value={productsDiscount.toLocaleString() + " " + messages.priceUnit}
                valueClassName="redColor largeTextBold"/>
            {excessDiscount > 0 &&
            <FullTitleValue
                className="marginTopBottomSmall"
                title={messages.excessDiscount}
                titleClassName="largeTextBold"
                value={excessDiscount.toLocaleString() + " " + messages.priceUnit}
                valueClassName="redColor largeTextBold"/>
            }
            {rewardDiscount > 0 &&
            <FullTitleValue
                className="marginTopBottomSmall"
                title={messages.specialDiscount}
                titleClassName="largeTextBold"
                value={rewardDiscount.toLocaleString() + " " + messages.priceUnit}
                valueClassName="redColor largeTextBold"/>
            }
            {totalUsedWallet > 0 &&
            <FullTitleValue
                className="marginTopBottomSmall"
                title={messages.wallet}
                titleClassName="largeTextBold"
                value={totalUsedWallet.toLocaleString() + " " + messages.priceUnit}
                valueClassName="redColor largeTextBold"/>
            }
            {props.fromOrderRegister &&
            <FullTitleValue
                className="marginTopBottomSmall"
                title={messages.transportationCost}
                titleClassName="largeTextBold"
                value={transportationCost === 0 ? messages.free :
                    transportationCost.toLocaleString() + " " + messages.priceUnit
                }
                valueClassName={transportationCost === 0 ? "greenColor largeTextBold" : "grayColor largeTextBold"}/>
            }
            <br/>
            <Divider/>
            <FullTitleValue
                className="marginTopBottomSmall"
                title={messages.netTotal}
                titleClassName="largeTextBold"
                value={netTotal.toLocaleString() + " " + messages.priceUnit}
                valueClassName="blueColor largeTextBold"/>
        </>
    }

    function buttons() {
        return <>
            {props.fromOrderRegister ?
                <div className="marginTopBottomSmall">
                    <IconTitleButtonRound
                        backgroundcolor={"var(--blue_3)"}
                        height={"3em"}
                        width={"100%"}
                        direction="ltr"
                        fontSize="mediumTextBold"
                        onClick={() => {
                            props.onRegisterClick()
                        }}
                        icon={<img className="xSmallIcon" src={ICDone} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"/>}
                        title={messages.finalRegister}/>
                </div> :
                <div className="vInT_hInLPFMS marginTopBottomSmall">
                    <div className={IsNotT() ?
                        "marginSmall halfWidth" : "marginTopBottomSmall fullWidth"}>
                        <IconTitleButtonRound
                            backgroundcolor={"var(--blue_3)"}
                            height={"3em"}
                            width={"100%"}
                            direction="ltr"
                            fontSize="mediumTextBold"
                            onClick={() => {
                                if (authenticationViewModel.isLogin) {
                                    props.onNavigate(history, "/orderRegister")
                                } else {
                                    props.onShowLogin({
                                        showLogin: true,
                                        goToLogin: () => {
                                            props.onNavigate(history, "/login")
                                        }
                                    })
                                }
                            }}
                            icon={<img className="xSmallIcon" src={ICAddress} alt="Ø¢Ø¯Ø±Ø³ ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"/>}
                            title={messages.selectTimeAddress}/>
                    </div>
                    <div className={IsNotT() ?
                        "marginSmall halfWidth" : "marginTopBottomSmall fullWidth"}>
                        <IconTitleButtonRound
                            backgroundcolor={"var(--red_3)"}
                            height={"3em"}
                            width={"100%"}
                            direction="ltr"
                            fontSize="mediumTextBold"
                            onClick={() => {
                                setClearBasketDialogShowStatus(true)
                            }}
                            icon={<img className="xSmallIcon" src={ICClear} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"/>}
                            title={messages.clearBasket}/>
                    </div>
                </div>
            }
        </>
    }

    useEffect(() => {
        const cart = props.cart
        if (cart) {
            setTotal(cart.total ? cart.total : 0)
            setProductsDiscount(cart.products_discount ? cart.products_discount : 0)
            setExcessDiscount(cart.excess_discount ? cart.excess_discount : 0)
            setNetTotal(cart.net_total ? cart.net_total : 0)
            setTotalUsedWallet(cart.total_used_wallet ? cart.total_used_wallet : 0)
            setRewardDiscount((cart.reward_discount && cart.reward_discount > 0) ?
                cart.reward_discount : 0)
            setTransportationCost((cart.transportation_cost && cart.transportation_cost > 0) ?
                cart.transportation_cost : 0)
        }
    }, [props])

    return (<div className="card paddingSmall">
            {prices()}
            <Divider/>
            <br/>
            <br/>
            {buttons()}
            <DialogMessage
                showStatus={clearBasketDialogShowStatus}
                title={messages.clearBasket}
                message={messages.sureClearBasket}
                submitTitle={messages.yes}
                closeTitle={messages.no}
                onCloseClicked={() => {
                    setClearBasketDialogShowStatus(false)
                }}
                onSubmitClicked={() => {
                    setClearBasketDialogShowStatus(false)
                    basketViewModel.clearCart(() => {

                    }, () => {
                        props.onAlert(messages.responseCodeIsNot200)
                    }, () => {
                        props.onLoading(true)
                    }, () => {
                        props.onLoading(false)
                    })
                }}
            />
        </div>
    )

}